/* PackageEditorGeneralTabRenderer.js */

"use strict";
const PackageDetails = require("./packagedetails/PackageDetailsComponent");
class PackageEditorGeneralTabRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("package-editor-general-tab-gl");
        this._rootElem.component = this._model;

        this._installedPackageDetails = new PackageDetails(this._model.packageEditorComponent.getLocalPkgDetails());
        this._availablePackageDetails = new PackageDetails(this._model.packageEditorComponent.getRemotePkgDetails());

        this._registerListeners();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _shutdown() {
        this._unregisterListeners();
        this._model = undefined;
        this._rootElem.remove();
        this._rootElem = undefined;
        return Promise.all([this._installedPackageDetails.shutdown(), this._availablePackageDetails.shutdown()]);
    }
    _registerListeners() {
        this._model.on("Shutdown", (this._onShutdown = this._onShutdown.bind(this)));
        this._model.on("ResizeContainer", (this._onResizeEvent = this._onResizeEvent.bind(this)));
        this._model.on("ResizeContainer", (this._onResizeEvent = this._onResizeEvent.bind(this)));
        this._model.packageEditorComponent.on("PackageInstalled", (this._onPackageInstalled = this._onPackageInstalled.bind(this)));
    }
    _unregisterListeners() {
        this._model.removeListener("Shutdown", this._onShutdown);
        this._model.removeListener("ResizeContainer", this._onResizeEvent);
        this._model.removeListener("PackageInstalled", this._onPackageInstalled);
        this._model.packageEditorComponent.removeListener("PackageInstalled", this._onPackageInstalled);
    }
    _onPackageInstalled() {
        this.render();
    }
    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        this._installedPackageDetails.setDetails(this._model.packageEditorComponent.getLocalPkgDetails());
        this._availablePackageDetails.setDetails(this._model.packageEditorComponent.getRemotePkgDetails());
        this._rootElem.innerHTML = `
            <installed-package-details>
                <h2>Installed Package Details</h2>
            </installed-package-details>
            <available-package-details>
                <h2>Available Package Details</h2>
            </available-package-details>
        `;

        let installedDetailsElem = this._rootElem.querySelector("installed-package-details");
        let availableDetailsElem = this._rootElem.querySelector("available-package-details");

        switch (this._model.packageEditorComponent.getDiffDetails()) {
            case "Same":
            case "LocalNewer":
            case "LocalOnly":
                //Display Local Installed Version
                installedDetailsElem.appendChild(this._installedPackageDetails.renderer.rootElement);

                //Display Local is Latest Version
                let latestVersionElem = document.createElement("p");
                latestVersionElem.innerText = `Package is Up To Date`;
                availableDetailsElem.appendChild(latestVersionElem);
                break;
            case "RemoteNewer":
                //Display Local Installed Version
                installedDetailsElem.appendChild(this._installedPackageDetails.renderer.rootElement);
                //Display Remote Available Version
                availableDetailsElem.appendChild(this._availablePackageDetails.renderer.rootElement);
                break;
            case "RemoteOnly":
                //Display Local is Not Installed  Version
                let notInstalledVersionElem = document.createElement("p");
                notInstalledVersionElem.innerText = `Package is Currently Not Installed`;
                installedDetailsElem.appendChild(notInstalledVersionElem);

                //Display Remote Available Version
                availableDetailsElem.appendChild(this._availablePackageDetails.renderer.rootElement);
                break;
        }

        return Promise.resolve();
    }
    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._rootElem;
    }
    get model() {
        return this.getModel();
    }
    getModel() {
        return this._model;
    }
    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/
    _onShutdown() {
        this._shutdown();
    }
    _onResizeEvent(/*width, height*/) {}
    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/
    //TODO - Nobody should be using methods on a Renderer directly so make all these methods private
    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}
module.exports = PackageEditorGeneralTabRenderer;
